import {
  AvailableGlobalPermissions,
  AvailablePermissionsValue,
  AvailableFlagPermissions,
  RequiredPermissions,
  AvailablePermissionFlagsValue,
} from 'features/validateAccess';

export const getProjectCreatePermissions = (accountId: string): RequiredPermissions => [
  [
    {
      type: 'global',
      global: AvailableGlobalPermissions.PROJECT,
      value: AvailablePermissionsValue.CREATE,
    },
    {
      type: 'subGlobal',
      global: AvailableGlobalPermissions.ACCOUNT,
      parent: accountId,
      subGlobal: AvailableGlobalPermissions.PROJECT,
      value: AvailablePermissionsValue.CREATE,
    },
  ],
];

export const getAccountNameViewPermission = (accountId: string): RequiredPermissions => [
  [
    {
      type: 'global',
      global: AvailableGlobalPermissions.ACCOUNT,
      value: AvailablePermissionsValue.READ,
    },
    {
      type: 'local',
      global: AvailableGlobalPermissions.ACCOUNT,
      local: accountId,
      value: AvailablePermissionsValue.READ,
    },
  ],
];

export const GLOBAL_EDIT_ACCOUNT_PERMISSION: RequiredPermissions = [
  [
    {
      type: 'global',
      global: AvailableGlobalPermissions.ACCOUNT,
      value: AvailablePermissionsValue.UPDATE,
    },
  ],
];

export const getLocalEditAccountPermission = (accountId: string): RequiredPermissions => [
  [
    {
      type: 'local',
      local: accountId,
      global: AvailableGlobalPermissions.ACCOUNT,
      value: AvailablePermissionsValue.UPDATE,
    },
  ],
];

export const getEditAllProjectPermissions = (accountId: string): RequiredPermissions => [
  [
    {
      type: 'global',
      global: AvailableGlobalPermissions.PROJECT,
      value: AvailablePermissionsValue.UPDATE,
    },
    {
      type: 'subGlobal',
      global: AvailableGlobalPermissions.ACCOUNT,
      parent: accountId,
      subGlobal: AvailableGlobalPermissions.PROJECT,
      value: AvailablePermissionsValue.UPDATE,
    },
  ],
];

export const getEditProjectLocalPermission = (projectId: string): RequiredPermissions => [
  [
    {
      type: 'local',
      global: AvailableGlobalPermissions.PROJECT,
      local: projectId,
      value: AvailablePermissionsValue.UPDATE,
    },
  ],
];

export const getGlobalReadPositionPermission = (accountId: string): RequiredPermissions => [
  [
    {
      type: 'global',
      value: AvailablePermissionsValue.READ,
      global: AvailableGlobalPermissions.POSITION,
    },
    {
      type: 'subGlobal',
      global: AvailableGlobalPermissions.ACCOUNT,
      parent: accountId,
      subGlobal: AvailableGlobalPermissions.POSITION,
      value: AvailablePermissionsValue.READ,
    },
  ],
];

export const getLocalReadPositionPermission = (projectId: string): RequiredPermissions => [
  [
    {
      type: 'subGlobal',
      global: AvailableGlobalPermissions.PROJECT,
      parent: projectId,
      subGlobal: AvailableGlobalPermissions.POSITION,
      value: AvailablePermissionsValue.READ,
    },
  ],
];

export const getProjectViewTimesheetPermission = (projectId: string): RequiredPermissions => [
  [
    {
      type: 'global',
      global: AvailableFlagPermissions.TIMESHEET_VIEW,
      value: AvailablePermissionFlagsValue.ENABLE,
    },
    {
      type: 'flagLocal',
      global: AvailableGlobalPermissions.PROJECT,
      subFlagGlobal: AvailableFlagPermissions.TIMESHEET_VIEW,
      parent: projectId,
      value: AvailablePermissionFlagsValue.ENABLE,
    },
  ],
];

export const getAccountViewTimesheetPermission = (accountId: string): RequiredPermissions => [
  [
    {
      type: 'global',
      global: AvailableFlagPermissions.TIMESHEET_VIEW,
      value: AvailablePermissionFlagsValue.ENABLE,
    },
    {
      type: 'flagLocal',
      global: AvailableGlobalPermissions.ACCOUNT,
      subFlagGlobal: AvailableFlagPermissions.TIMESHEET_VIEW,
      parent: accountId,
      value: AvailablePermissionFlagsValue.ENABLE,
    },
  ],
];
